import { useState } from "react";

const EMPTY_FORM = { name: "", telegram_id: "", isAdmin: false };

export const useUserForm = () => {
    const [form, setForm] = useState(EMPTY_FORM);
    const [mode, setMode] = useState('add');
    const [currentTelegramId, setCurrentTelegramId] = useState(null);

    const openAdd = () => {
        setForm(EMPTY_FORM);
        setMode('add');
        setCurrentTelegramId(null);
    }
    const openEdit = (user) => {
        setForm({ name: user.name, telegramId: user.telegram_id, isAdmin: user.is_admin });
        setMode('edit');
        setCurrentTelegramId(user.telegram_id);
    }
    const setField = (field) => value => setForm(f => ({ ...f, [field]: value}));

    return { form, mode, currentTelegramId, openAdd, openEdit, setField };
};